// Shared helper for building the `Authorization` header used by every
// service module under `frontend/src/services/`.
//
// Before this utility existed, ten separate service files defined an
// identical `authHeaders(token)` helper inline. The shared version is
// a pure function — no React, no fetching, no service-specific
// knowledge — so it can be reused by any module that needs to attach a
// bearer token to a request.
//
// Returns an empty object when the token is null/undefined so callers
// can safely spread it into a `headers` literal without a conditional
// at the call site:
//
//   headers: { "Content-Type": "application/json", ...authHeaders(token) }

/**
 * Build the `Authorization` header for a bearer token request.
 *
 * @param token A Firebase/Clerk user token, or `null`/`undefined` for
 *   unauthenticated calls. When falsy, returns an empty header object
 *   so the caller can spread it unconditionally.
 * @returns A `Record<string, string>` containing `Authorization` when
 *   `token` is provided, otherwise `{}`.
 */
export const authHeaders = (token: string | null | undefined): Record<string, string> => {
  if (!token) return {};
  return { Authorization: `Bearer ${token}` };
};
